module.exports = __webpack_public_path__ + "static/media/PushtimargImage13.a9c7cec4.jpg";